import { useState } from 'react';
import { Industry } from 'modules/project-list/components/project-card/modal';
import { IndustryType } from 'modules/project-management/models/interfaces';

export function useIndustries(
  initialIndustries?: Industry[],
  industryTypefromLens?: IndustryType
) {
  function getInitialIndustryType(
    industries?: Industry[],
    industryType?: IndustryType
  ): IndustryType {
    if (industryType === undefined) {
      if (!industries || industries.length === 0) {
        return undefined;
      }
      if (
        industries.length === 1 &&
        industries[0].name &&
        industries[0].externalId === '-1'
      ) {
        return 'any';
      }
      return 'specific';
    } else {
      return industryType;
    }
  }

  const [industryType, setIndustryType] = useState<IndustryType>(
    getInitialIndustryType(initialIndustries, industryTypefromLens)
  );

  return {
    industryType,
    setIndustryType,
  };
}
